import script from "./NicknameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NicknameCard.vue?vue&type=script&setup=true&lang=js"

import "./NicknameCard.vue?vue&type=style&index=0&id=89d83720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d83720"]])

export default __exports__